import { createFileRoute } from '@tanstack/react-router';
import AutoReports from '../../components/AutoReports';

// No permission gate: matches the original (wouter) router, where /auto-reports rendered for any
// logged-in user (no `access` prop). Visibility is controlled by the backend-driven main menu.
export const Route = createFileRoute('/_authenticated/auto-reports/')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'tab.auto-report',
        suffix: 'menu.autoReports',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AutoReportsRoute,
});

function AutoReportsRoute() {
  return <AutoReports />;
}
